import service from '@/utils/server';

const modName='/bd/collectionLandDeductionState/';
//查询结算信息
export const pageInfo = data => {
  return service({
    url: modName + 'pageInfo',
    method: 'post',
    data
  });
};

//结算详情
export const collectionDetails = data => {
  return service({
    url: modName + 'detail',
    method: 'post',
    data
  });
};


export const exportData = data => {
  return service({
    url: modName + 'export',
    method: 'post',
    responseType: 'blob',
    data
  });
};


//确认可付款
export const confirmPayable = data => {
  return service({
    url: modName + 'confirmPayable',
    method: 'post',
    data
  });
};



// WEBPACK FOOTER //
// ./src/page/bd/run/collectionLandDeductionState/api/index.js